import { Table } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import PressManagementTableBody from "./PressManagementTableBody";
import PressManagementTableHead from "./PressManagementTableHead";

/**
 * PressManagementTableコンポーネント.
 *
 * @param {object} sortState ソート状態
 * @param {function} onHeaderClick ヘッダー押下時の処理
 * @return {object} コンポーネント
 */
function PressManagementTable(props) {
  // 引数
  const { sortState, onHeaderClick } = props;

  return (
    <Table>
      <PressManagementTableHead sortState={sortState} onClick={onHeaderClick} />
      <PressManagementTableBody sortState={sortState} />
    </Table>
  );
}

PressManagementTable.propTypes = {
  sortState: PropTypes.shape({
    key: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  onHeaderClick: PropTypes.func.isRequired,
};

export default PressManagementTable;
